import { useState, useCallback } from 'react';
import Slider from '@mui/material/Slider';
import styled, { css } from 'styled-components';
import debounce from 'lodash.debounce';
import { themeGet } from '@styled-system/theme-get';

export const PointsSlider = ({ points, handleChange }) => {
  const [sliderPoints, setSliderPoints] = useState(points);

  const debouncedHandleChange = useCallback(
    debounce(value => handleChange(value), 500),
    [],
  );

  return (
    <CustomSlider
      valueLabelDisplay="on"
      aria-label="Points"
      value={sliderPoints}
      min={1}
      max={20}
      onChange={(_, newPoints) => {
        setSliderPoints(newPoints);
        debouncedHandleChange(newPoints);
      }}
    />
  );
};

const styles = css({
  '& .MuiSlider-thumb': {
    height: 24,
    width: 24,
    backgroundColor: themeGet('colors.white'),
    border: '4px solid currentColor',
    '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
      boxShadow: 'inherit',
    },
    '&:before': {
      display: 'none',
    },
  },
  '& .MuiSlider-valueLabel': {
    lineHeight: 1.2,
    fontSize: 12,
    background: 'unset',
    padding: 0,
    width: 32,
    height: 32,
    borderRadius: '8px',
    backgroundColor: themeGet('colors.peach'),
  },
});

const CustomSlider = styled(Slider)`
  color: ${themeGet('colors.peach')} !important;
  margin-top: 50px;
  ${styles};
`;
